import React, { useState } from "react";
import { Select } from "antd";
import "./style.css";

const CustomSelect = ({ options, label, value, placeholder, required, size, defaultValue, defaultFocus, onChange, ...props }) => {
    const [focus, setFocus] = useState(defaultFocus || false);

    if (!placeholder) placeholder = label;
  
    const isOccupied = focus || (value && value.length !== 0);
  
    const labelClass = isOccupied ? "label as-label" : "label as-placeholder";
  
    const requiredMark = required ? <span className='text-danger'>*</span> : null;
  return (
    <div
    className='float-label'
    onBlur={() => setFocus(false)}
    onFocus={() => setFocus(true)}
  >
    <Select size={size || "large"} options={options} onChange={onChange} defaultValue={defaultValue} {...props}  />
    <label className={labelClass}>
        {isOccupied ? label : placeholder} {requiredMark}
      </label>
    </div>
  );
};

export default CustomSelect;
